import { WORKER_USER_ROLE } from '../../../../../../../../constants/user'
import { toUserSelectItem } from '../../../../../../../User'

export function getSideWorkerSelectItemByEmail(email) {
  return {
    ...toUserSelectItem({
      archived: false,
      email,
      fullname: email,
      id: email,
      role: WORKER_USER_ROLE,
    }),
    isNewWorkerEmail: true,
  }
}
